var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor meta-send-capi-event" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Contact ID")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Contact ID",
            "show-attributes": true,
            "max-character-count": 100,
          },
          model: {
            value: _vm.clone.contactId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "contactId", $$v)
            },
            expression: "clone.contactId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Event Tipi")]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "classic-new-select",
            attrs: { placeholder: "Event tipi seçin" },
            model: {
              value: _vm.clone.eventType,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "eventType", $$v)
              },
              expression: "clone.eventType",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "LeadSubmitted" } }, [
              _vm._v("Lead Gönderildi"),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "Purchase" } }, [
              _vm._v("Satın Alma"),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "InitiateCheckout" } }, [
              _vm._v("Sohbet Başlatıldı"),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "AppointmentBooked" } }, [
              _vm._v("Randevu Oluşturuldu"),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "AddToCart" } }, [
              _vm._v("Sepete Eklendi"),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "ViewContent" } }, [
              _vm._v("İçerik Görüntülendi"),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "OrderCreated" } }, [
              _vm._v("Sipariş Oluşturuldu"),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "OrderShipped" } }, [
              _vm._v("Sipariş Kargoya Verildi"),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    ["Purchase", "OrderCreated", "OrderShipped"].includes(_vm.clone.eventType)
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v("Para Birimi"),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "TRY, USD, EUR",
                "show-attributes": true,
                "max-character-count": 10,
              },
              model: {
                value: _vm.clone.currency,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "currency", $$v)
                },
                expression: "clone.currency",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    ["Purchase", "OrderCreated", "OrderShipped"].includes(_vm.clone.eventType)
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [_vm._v("Tutar")]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Örn: \\{\\{order_total\\}\\} veya 99.99",
                "show-attributes": true,
                "max-character-count": 50,
              },
              model: {
                value: _vm.clone.value,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "value", $$v)
                },
                expression: "clone.value",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "editor-row" }, [
      _c("div", { staticClass: "editor-row-title" }, [
        _vm._v("Ek Bilgiler (Opsiyonel)"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "custom-data-list" },
        [
          _vm._l(_vm.clone.customData, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "custom-data-item" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: item.key,
                      expression: "item.key",
                    },
                  ],
                  staticClass: "key-input",
                  attrs: { placeholder: "Anahtar" },
                  domProps: { value: item.key },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(item, "key", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("TiptapEditor", {
                  staticClass: "value-input",
                  attrs: {
                    placeholder: "Değer",
                    "show-attributes": true,
                    "max-character-count": 200,
                  },
                  model: {
                    value: item.value,
                    callback: function ($$v) {
                      _vm.$set(item, "value", $$v)
                    },
                    expression: "item.value",
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "remove-btn",
                    on: {
                      click: function ($event) {
                        return _vm.removeCustomData(index)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "add-btn", on: { click: _vm.addCustomData } },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v("\n                Ek Alan Ekle\n            "),
            ]
          ),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-box" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            CAPI eventi göndermek için visitor'ın kanalında CAPI ayarlarının yapılmış olması gerekir. Belirtilen\n            Contact ID üzerinden kanal ve gerekli Meta bilgileri (Instagram User ID, Messenger User ID, Meta Lead\n            ID vb.) otomatik olarak alınacaktır.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }